import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import PriceInsurance from "./PriceInsuranceForm/PriceInsurance";
import { ITicketAutomationReceivedRulePriceInsurance } from "../../../../../../models/ticket-automation-received-rule-price-insurance";

const TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRulePriceInsurance/";
const ticketAutomationReceivedRulesService =
  new MainApi<ITicketAutomationReceivedRulePriceInsurance>(
    TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRulePriceInsurance.";

const PriceInsurancePage = () => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [priceInsuranceForm, setPriceInsuranceForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<ITicketAutomationReceivedRulePriceInsurance>[] = [
    {
      field: "externalId",
      headerName: t(translationPath + "external_id") || "External ID",
    },
    {
      field: "externalName",
      headerName: t(translationPath + "external_name") || "External Name",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setPriceInsuranceForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationReceivedRulePriceInsurance>,
  ) => {
    if (!params.row) return;
    setPriceInsuranceForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setPriceInsuranceForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, [ticketAutomationReceivedRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {priceInsuranceForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <PriceInsurance
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!priceInsuranceForm && (
        <Box height={600}>
          <Table<ITicketAutomationReceivedRulePriceInsurance>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedRulesService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_insurance") ||
              "Add Automation Tasy Orientation"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default PriceInsurancePage;
